<template>
  <div class="d-inline">
    <button type="button" :class="btnClass" data-toggle="modal" :data-target="`#${modalID}`">
      <slot> <i class="flaticon2-download"></i> Download </slot>
    </button>

    <div class="modal fade" :id="modalID" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="la la-download"></i>
              Download Output/Feedback Files
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="overflow: auto; max-height: 500px;">
            <div class="row">
              <!-- Output Files -->
              <div class="col-md-5 download-section">
                <h6 class="download-section__title">
                  <i class="la la-file-archive-o mr-1"></i> Output Files
                </h6>
                <div v-if="order.output && order.output.length" class="list-group">
                  <div v-for="(file, index) in order.output" :key="index">
                    <a
                      :href="file.path"
                      class="border-0 d-flex align-items-center justify-content-between list-group-item list-group-item-action"
                      target="_blank"
                    >
                      <span class="file-name">{{ file.name }}</span>
                      <span class="la la-download ml-2 flex-shrink-0"></span>
                    </a>
                    <div v-if="index + 1 !== order.output.length" class="dropdown-divider"></div>
                  </div>
                </div>
                <p v-else class="text-muted small mt-2">No output files available.</p>
              </div>

              <div class="col-md-1 d-none d-md-flex justify-content-center">
                <div class="download-section__divider"></div>
              </div>

              <!-- Feedback Files -->
              <div class="col-md-6 download-section">
                <h6 class="download-section__title">
                  <i class="la la-comments mr-1"></i> Feedback Files
                </h6>
                <template v-if="hasFeedbackFiles">
                  <div
                    v-for="stageGroup in order.feedback"
                    :key="stageGroup.stage"
                    class="mb-3"
                  >
                    <div class="download-section__stage-label">Feedback {{ stageGroup.stage }}</div>
                    <div class="dropdown-divider"></div>
                    <div class="list-group">
                      <div v-for="(file, index) in stageGroup.files" :key="index">
                        <a
                          :href="file.download_url"
                          class="border-0 d-flex align-items-center justify-content-between list-group-item list-group-item-action"
                          target="_blank"
                        >
                          <span class="file-name">{{ file.name }}</span>
                          <span class="la la-download ml-2 flex-shrink-0"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </template>
                <p v-else class="text-muted small mt-2">No feedback files uploaded yet.</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: "btn btn-success btn-sm btn-upper",
    },
  },

  computed: {
    modalID() {
      return `download-file-modal-${this.order.id}`;
    },
    hasFeedbackFiles() {
      return Array.isArray(this.order.feedback) && this.order.feedback.length > 0;
    },
  },
};
</script>

<style scoped>
.download-section__title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #e5e7eb;
}
.download-section__divider {
  width: 1px;
  background-color: #e5e7eb;
  min-height: 100%;
}
.download-section__stage-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 0.35rem;
}
.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
